import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import Globals from '../../Globals';

//#region ENUMS
/*
    Enumerador para tipos de diseño de input 
    Valor por defecto: AUTOCOMPLETE
*/
export const INPUT_TYPES = {
    AUTOCOMPLETE_MULTIPLE: 'AUTOCOMPLETE_MULTIPLE',
    AUTOCOMPLETE: 'AUTOCOMPLETE',
    BUTTON_GROUP_MULTIPLE: 'BUTTON_GROUP_MULTIPLE',
    BUTTON_GROUP: 'BUTTON_GROUP',
};

/* Enumerador para cada tipo de dato seleccionado */
export const DATA_TYPES = {
    REGION: 'region',
    GROUP: 'group',
    DEALERSHIP: 'dealership',
    DEALER: 'dealer',
};

//Labels en cada uno de los inputs
const DATA_TYPES_LABEL = {
    REGION: 'Región',
    GROUP: 'Grupo',
    DEALERSHIP: 'Concesión',
    DEALER: 'Vendedor',
};

export const ID_CLIENTE = 'idCliente';

//#endregion

//#region Componente funcional
export default function CanalsAdapter(props) {
    const [defaultInputs, setDefaultInputs] = useState([]);
    const [dealershipGroup, setDealershipGroup] = useState({});
    const [dealershipRegion, setDealershipRegion] = useState({});
    const [dealership, setDealership] = useState({});
    const [dealer, setDealer] = useState({});

    const [dealershipGroupLoading, setDealershipGroupLoading] = useState(false);
    const [dealershipRegionLoading, setDealershipRegionLoading] =
        useState(false);
    const [dealershipLoading, setDealershipLoading] = useState(false);
    const [dealerLoading, setDealerLoading] = useState(false);

    const [dealershipGroupURL, setDealershipGroupURL] = useState(false);
    const [dealershipRegionURL, setDealershipRegionURL] = useState(false);
    const [dealershipURL, setDealershipURL] = useState(false);
    const [dealerURL, setDealerURL] = useState(false);

    const [isSetFirstTimeElements, setIsSetFirstTimeElements] = useState(false);
    const [error, setError] = useState(null);
    const [idCliente, setIdCliente] = useState('');

    useEffect(() => {
        startInputForm();
    }, []);

    useEffect(() => {
        if (
            defaultInputs.length > 0 &&
            !isSetFirstTimeElements &&
            idCliente != ''
        ) {
            getFirstTimeElements();
        }
    }, [defaultInputs, idCliente]);

    useEffect(() => {
        if (dealershipRegion.elements && dealershipRegion.elements.length > 0) {
            if (dealershipRegionLoading) {
                setDealershipRegionLoading(false);
            }
        }
    }, [dealershipRegion]);

    useEffect(() => {
        if (dealershipGroup.elements && dealershipGroup.elements.length > 0) {
            if (dealershipGroupLoading) {
                setDealershipGroupLoading(false);
            }
        }
    }, [dealershipGroup]);

    useEffect(() => {
        if (dealership.elements && dealership.elements.length > 0) {
            if (dealershipLoading) {
                setDealershipLoading(false);
            }
        }
    }, [dealership]);

    useEffect(() => {
        if (dealer.elements && dealer.elements.length > 0) {
            if (dealerLoading) {
                setDealerLoading(false);
            }
        }
    }, [dealer]);

    //inicializa el orden y los valores de cada tipo de input.
    const startInputForm = () => {
        try {
            let auxInputs = {};
            let arrayInputs = [];
            for (var [key, value] of Object.entries(props)) {
                if (key == ID_CLIENTE) {
                    setIdCliente(value);
                } else if (key) {
                    if (Object.values(DATA_TYPES).includes(key)) {
                        auxInputs = {
                            id: key,
                            type: null,
                            value: null,
                            withTitle: value.withTitle
                                ? value.withTitle
                                : false,
                            flex: value.flex ? value.flex : '1/1',
                            elements: [],
                            parentChange: value.onChange
                                ? value.onChange
                                : null,
                            defaultValue: value.defaultValue
                                ? value.defaultValue
                                : null,
                            token: value.token ? value.token : null,
                        };
                        if (value.type) {
                            if (Object.keys(INPUT_TYPES).includes(value.type)) {
                                auxInputs.type = value.type;
                            } else {
                                let error = {
                                    code: 404,
                                    message:
                                        'No se han enviado las props optionals.type correctamente, revisar documentacion del componente',
                                };
                                setError(error);
                                throw error;
                            }
                        } else {
                            auxInputs.type = INPUT_TYPES.AUTOCOMPLETE;
                        }
                        switch (key) {
                            case DATA_TYPES.REGION:
                                arrayInputs.push({ id: key, order: 1 });
                                setDealershipRegionURL(value.baseURL);
                                setDealershipRegion(auxInputs);
                                break;
                            case DATA_TYPES.GROUP:
                                arrayInputs.push({ id: key, order: 2 });
                                setDealershipGroupURL(value.baseURL);
                                setDealershipGroup(auxInputs);
                                break;
                            case DATA_TYPES.DEALERSHIP:
                                arrayInputs.push({ id: key, order: 3 });
                                setDealershipURL(value.baseURL);
                                setDealership(auxInputs);
                                break;
                            case DATA_TYPES.DEALER:
                                arrayInputs.push({ id: key, order: 4 });
                                setDealerURL(value.baseURL);
                                setDealer(auxInputs);
                                break;
                        }
                    } else {
                        let error = {
                            code: 404,
                            message:
                                'No se han enviado las props de datos correctamente, revisar documentacion del componente',
                        };
                        setError(error);
                        throw error;
                    }
                } else {
                    let error = {
                        code: 404,
                        message:
                            'No se han enviado las props de datos correctamente, revisar documentacion del componente',
                    };
                    setError(error);
                    throw error;
                }
            }
            if (arrayInputs.length == 0) {
                let error = {
                    code: 404,
                    message:
                        'No se han enviado las props de datos correctamente, revisar documentacion del componente',
                };
                setError(error);
                throw error;
            }
            arrayInputs = arrayInputs.sort((a, b) => a.order - b.order);
            setDefaultInputs(arrayInputs);
        } catch (e) {
            let error = { code: 404, message: e.message };
            setError(error);
            console.error(e.message);
        }
    };

    const getFirstTimeElements = async () => {
        try {
            let functionsAsync = [];
            if (isIDInInputs(DATA_TYPES.REGION))
                functionsAsync.push(getRegionElements());
            if (isIDInInputs(DATA_TYPES.GROUP))
                functionsAsync.push(getGroupElements());
            functionsAsync.push(getDealershipElements());

            Promise.all(functionsAsync).then(values => {
                setIsSetFirstTimeElements(true);
            });
        } catch (e) {
            let error = { code: 500, message: e.message };
            setError(error);
        }
    };

    const getRegionElements = async () => {
        try {
            setDealershipRegionLoading(true);
            let result = await CanalsService.getRegions({
                baseURL: dealershipRegionURL,
                idCliente,
            });
            if (result) {
                if (result.length > 0) {
                    updatePropertyInput(DATA_TYPES.REGION, 'elements', result);
                } else removeInputFromArrayByID(DATA_TYPES.REGION);
            } else {
                let error = {
                    code: 500,
                    message:
                        'Error del lado del servidor al momento de traer datos',
                };
                setError(error);
                throw error;
            }
        } catch (err) {
            let error = {
                code: 500,
                message:
                    'Error del lado del servidor al momento de traer datos',
            };
            console.error(err);
            setError(error);
            throw error;
        }
    };

    const getGroupElements = async region => {
        try {
            setDealershipGroupLoading(true);
            let result = await CanalsService.getGroups({
                baseURL: dealershipGroupURL,
                idCliente,
                region,
            });
            if (result) {
                if (result.length > 0) {
                    updatePropertyInput(DATA_TYPES.GROUP, 'elements', result);
                } else removeInputFromArrayByID(DATA_TYPES.GROUP);
            } else {
                let error = {
                    code: 500,
                    message:
                        'Error del lado del servidor al momento de traer datos',
                };
                setError(error);
                throw error;
            }
        } catch (err) {
            let error = {
                code: 500,
                message:
                    'Error del lado del servidor al momento de traer datos',
            };
            console.error(err);
            setError(error);
            throw error;
        }
    };

    const getDealershipElements = async data => {
        try {
            setDealershipLoading(true);
            let result = await CanalsService.getDealership({
                token: dealership.token,
                baseURL: dealershipURL,
                idCliente,
                ...data,
            }); //await CanalsService({idCliente});//
            if (result) {
                updatePropertyInput(DATA_TYPES.DEALERSHIP, 'elements', result);
            } else {
                let error = {
                    code: 500,
                    message:
                        'Error del lado del servidor al momento de traer datos',
                };
                setError(error);
                throw error;
            }
        } catch (err) {
            let error = {
                code: 500,
                message:
                    'Error del lado del servidor al momento de traer datos',
            };
            console.error(err);
            setError(error);
            throw error;
        }
    };

    const getDealerElements = async idDealership => {
        try {
            setDealerLoading(true);
            let result = await CanalsService.getDealers({
                baseURL: dealerURL,
                idCliente,
                idDealer: idDealership,
            });
            if (result) {
                updatePropertyInput(DATA_TYPES.DEALER, 'elements', result);
            } else {
                let error = {
                    code: 500,
                    message:
                        'Error del lado del servidor al momento de traer datos',
                };
                setError(error);
                throw error;
            }
        } catch (err) {
            let error = {
                code: 500,
                message:
                    'Error del lado del servidor al momento de traer datos',
            };
            console.error(err);
            setError(error);
            throw error;
        }
    };

    const isIDInInputs = id =>
        defaultInputs.find(item => item.id === id) != undefined;

    const removeInputFromArrayByID = id => {
        if (!isSetFirstTimeElements)
            setDefaultInputs(defaultInputs.filter(item => item.id !== id));
    };

    const resetValueInput = (index, recursive = true) => {
        let [state, setState] = getInput(defaultInputs[index].id);

        let duplicate = { ...state };
        duplicate.value = null;
        duplicate.loading = false;
        duplicate.elements = [];

        if (state.parentChange) state.parentChange(duplicate);
        setState(duplicate);

        if (recursive && defaultInputs[index + 1]) {
            resetValueInput(index + 1);
        }
    };

    const getInput = id => {
        switch (id) {
            case DATA_TYPES.REGION:
                return [dealershipRegion, setDealershipRegion];
            case DATA_TYPES.GROUP:
                return [dealershipGroup, setDealershipGroup];
            case DATA_TYPES.DEALERSHIP:
                return [dealership, setDealership];
            case DATA_TYPES.DEALER:
                return [dealer, setDealer];
            default:
        }
    };

    const getLoading = id => {
        switch (id) {
            case DATA_TYPES.REGION:
                return dealershipRegionLoading;
            case DATA_TYPES.GROUP:
                return dealershipGroupLoading;
            case DATA_TYPES.DEALERSHIP:
                return dealershipLoading;
            case DATA_TYPES.DEALER:
                return dealerLoading;
            default:
        }
    };

    const getError = () => {
        return [<h2>{error.code}</h2>, <span>{error.message}</span>];
    };

    const updatePropertyInput = (id, prop, value) => {
        let [input, setInput] = getInput(id);
        const newInput = { ...input };
        newInput[prop] = value;
        setInput(newInput);
    };

    const updateInputs = (event, id, recursive = true) => {
        let elementByIndex = getInput(id)[0];
        let value;

        if (event instanceof HTMLElement) {
            event.preventDefault();
            value = event.event.target.value;
        } else {
            value = event;
        }

        if (elementByIndex.parentChange) elementByIndex.parentChange(event);

        updatePropertyInput(id, 'value', value);
        getChildrenElementsOfNextOrderInput(id, value);

        if (recursive) {
            let index = getIndex(id);
            if (defaultInputs[index + 1]) {
                resetValueInput(index + 1);
            }
        }
    };

    const getIndex = id =>
        defaultInputs.indexOf(defaultInputs.find(item => item.id == id));

    const getChildrenElementsOfNextOrderInput = async (id, value) => {
        try {
            let index = getIndex(id);
            /*si no es el ultimo */
            if (defaultInputs[index + 1]) {
                switch (id) {
                    case DATA_TYPES.REGION:
                        if (isIDInInputs(DATA_TYPES.GROUP)) {
                            getGroupElements(value);
                            getDealershipElements({ region: value });
                        } else {
                            getDealershipElements({ region: value });
                        }
                        break;
                    case DATA_TYPES.GROUP:
                        let data = { group: value };
                        if (isIDInInputs(DATA_TYPES.REGION)) {
                            data.region = dealershipRegion.value;
                        }
                        getDealershipElements(data);
                        break;
                    case DATA_TYPES.DEALERSHIP:
                        if (isIDInInputs(DATA_TYPES.DEALER))
                            getDealerElements(value);
                        break;
                    default:
                        break;
                }
            }
        } catch (e) {
            console.error(e);
        }
    };

    const getRender = () => {
        return (
            <div
                className={'o-layout__item u-p-none u-block' + props.className}
            >
                {defaultInputs.map(item => (
                    <RenderTypeCanal
                        key={`${item.order}__${item.id}`}
                        {...getInput(item.id)[0]}
                        loading={getLoading(item.id)}
                        onChange={updateInputs}
                    />
                ))}
            </div>
        );
    };

    const getFakesInputs = () => {
        let res = [];
        for (let index = 0; index < defaultInputs.length; index++) {
            res.push(
                <FakeInputs
                    key={index}
                    show={true}
                    totalInputs={defaultInputs.length}
                />
            );
        }
        return res;
    };

    return (
        <React.Fragment>
            {!error
                ? defaultInputs.length != 0 && isSetFirstTimeElements
                    ? getRender()
                    : getFakesInputs()
                : getError()}
        </React.Fragment>
    );
}
CanalsAdapter.propTypes = {
    idCliente: PropTypes.string.isRequired,
    dealership: PropTypes.shape({
        type: PropTypes.string,
        onChange: PropTypes.func,
        defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    }).isRequired,
    region: PropTypes.shape({
        type: PropTypes.string,
        onChange: PropTypes.func,
        defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    }),
    group: PropTypes.shape({
        type: PropTypes.string,
        onChange: PropTypes.func,
        defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    }),
    dealer: PropTypes.shape({
        type: PropTypes.string,
        onChange: PropTypes.func,
        defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    }),
};

//#endregion

//#region Componente de render
export function RenderTypeCanal(props) {
    const generateInput = () => {
        switch (props.type) {
            case INPUT_TYPES.AUTOCOMPLETE:
                let optionAutocomplete = {
                    label: props.withTitle
                        ? DATA_TYPES_LABEL[props.id.toUpperCase()]
                        : null,
                    values: props.elements, //data,
                    id: `${props.order}__${props.id}`,
                    loading: props.loading,
                    defaultValue: props.defaultValue,
                    default: 'Sin resultados',
                };
                return (
                    <SelectFree
                        key={`${props.order}__${props.id}`}
                        options={optionAutocomplete}
                        onChange={e => {
                            props.onChange(e, props.id);
                        }}
                        value={props.value}
                    />
                );
            case INPUT_TYPES.BUTTON_GROUP_MULTIPLE:
                return (
                    <ButtonGroup
                        elements={props.elements}
                        multiple={true}
                        loading={props.loading}
                        defaultValue={props.defaultValue}
                        value={props.value}
                        onChange={e => {
                            props.onChange(e, props.id);
                        }}
                    />
                );
            case INPUT_TYPES.BUTTON_GROUP:
                return (
                    <ButtonGroup
                        elements={props.elements}
                        value={props.value}
                        loading={props.loading}
                        defaultValue={props.defaultValue}
                        onChange={e => {
                            props.onChange(e, props.id);
                        }}
                    />
                );

            case INPUT_TYPES.AUTOCOMPLETE_MULTIPLE:
                let optionSelectedMultiple = {
                    label: props.withTitle
                        ? DATA_TYPES_LABEL[props.id.toUpperCase()]
                        : null,
                    values: props.elements,
                    id: `${props.order}__${props.id}`,
                    loading: props.loading,
                    defaultValue: props.defaultValue,
                    default: 'Sin resultados',
                };
                return (
                    <SelectFreeMultiple
                        key={`${props.order}__${props.id}`}
                        options={optionSelectedMultiple}
                        onChange={e => {
                            props.onChange(e, props.id);
                        }}
                        value={props.value}
                    />
                );
            default:
                break;
        }
    };

    return (
        <React.Fragment>
            <div className={`o-layout__item u-1/1@s u-${props.flex}`}>
                <div>{generateInput()}</div>
            </div>
        </React.Fragment>
    );
}

//#endregion

//#region Componentes Individuales

export function SelectFreeMultiple({
    options,
    value,
    onChange,
    textDisplay = 'name',
    selectedId = 'id',
}) {
    const [arrayValues, setArrayValues] = useState([]);
    const [filteredArrayValues, setFilteredArrayValues] = useState([]);
    const [inputValue, setInputValue] = useState('');
    const [index, setIndex] = useState(0);
    const [display, setDisplay] = useState(true);
    const [setInitState, setSetInitState] = useState(true);

    const wrapperRef = useRef();

    useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);

    useEffect(() => {
        if (options.values.length !== arrayValues.length) {
            let copy = options.values.map(item =>
                Object.defineProperty(item, 'selected', {
                    value: false,
                    writable: true,
                })
            );

            if (setInitState && options.defaultValue) {
                for (const iterator of options.defaultValue) {
                    let indexCopy = copy.findIndex(item => item.id == iterator);
                    if (indexCopy > -1) {
                        copy[indexCopy].selected = true;
                    }
                }

                let copySelected = copy.filter(item => item.selected == true);
                let selectedValues = copySelected.map(item => item[selectedId]);
                onChange(selectedValues);
                setInputValue(
                    copySelected.map(item => item[textDisplay]).toString() + ','
                );
                setSetInitState(false);
            }

            setArrayValues(copy);
        }
    }, [options.values]);

    useEffect(() => {
        setFilteredArrayValues(arrayValues);
    }, [arrayValues]);

    useEffect(() => {
        if (!value) {
            if (!options.defaultValue) onChangeInput('');
            setDisplay(false);
        }
    }, [value]);

    const handleClickOutside = event => {
        if (display == true) {
            if (!wrapperRef.current.contains(event.target)) {
                setDisplay(false);
            }
        }
    };

    const onClickDropDown = () => {
        if (value === 0 && options.value) {
            options.values[0].selected = true;
        }
        setDisplay(true);
        document.getElementById('select_free_' + options.id).focus();
    };

    const onChangeInput = value => {
        //if (filteredArrayValues.length > 0) filteredArrayValues[index].selected = false;
        let aux = value.split(',');
        let lastvalue = aux.length > 1 ? aux[aux.length - 1] : value;
        setDisplay(true);
        setInputValue(value);
        setFilteredArrayValues(
            arrayValues.filter(valueOption =>
                valueOption[textDisplay]
                    .toLowerCase()
                    .includes(lastvalue.toLowerCase())
            )
        );
    };

    const onChangeSelect = selectValue => {
        if (filteredArrayValues.length > 0) {
            let newArray = [...arrayValues];
            let index = newArray.indexOf(selectValue);
            newArray[index].selected = !selectValue.selected;
            setArrayValues(newArray);

            let arraySelectedValues =
                inputValue != '' ? inputValue.split(',') : null;
            if (arraySelectedValues) arraySelectedValues.pop();
            if (selectValue.selected) {
                //esta seleccionado hay que agregarlo
                let input = arraySelectedValues
                    ? arraySelectedValues.concat(newArray[index][textDisplay])
                    : newArray[index][textDisplay];
                setInputValue(input.toString() + ',');

                /*tener lo valores en el padre*/
                let selected = value
                    ? value.concat(selectValue[selectedId])
                    : [selectValue[selectedId]];
                onChange(selected);
            } else {
                //se debe sacar del array
                arraySelectedValues = arraySelectedValues.filter(
                    item => item != options.values[index][textDisplay]
                );
                let stringToInput =
                    arraySelectedValues.length > 0
                        ? arraySelectedValues.toString() === ''
                            ? ''
                            : arraySelectedValues.toString() + ','
                        : '';
                setInputValue(stringToInput);

                let selected = value.filter(
                    item => item != selectValue[selectedId]
                );
                onChange(selected);
            }
        }
    };

    const onKeyPress = e => {
        var ul = document.getElementsByClassName(
            'c-custom-select__dropdown'
        )[0];
        var li = document.querySelector('#li_bronson_' + index).offsetTop;
        switch (e.key) {
            case 'Enter':
                onChangeSelect(filteredArrayValues[index]);
                break;
            case 'ArrowUp':
                if (index > 0) filteredArrayValues[index].selected = false;
                if (index > 0) filteredArrayValues[index - 1].selected = true;
                if (index > 0) setIndex(index - 1);
                ul.scroll({ behavior: 'smooth', top: li - 100 });
                break;
            case 'ArrowDown':
                if (index < filteredArrayValues.length - 1)
                    filteredArrayValues[index].selected = false;
                if (index < filteredArrayValues.length - 1)
                    filteredArrayValues[index + 1].selected = true;
                if (index < filteredArrayValues.length - 1) setIndex(index + 1);
                ul.scroll({ behavior: 'smooth', top: li });
                break;
            default:
                break;
        }
    };

    const showLabel = label => {
        if (label) {
            return <label className="c-form-field__label">{label}</label>;
        }
    };

    return (
        <React.Fragment>
            {showLabel(options.label)}
            <div className="c-custom-select" ref={wrapperRef}>
                <div className="c-input">
                    <input
                        // onBlur={onFocusOut}
                        onKeyPress={e => onKeyPress(e)}
                        onFocus={onClickDropDown}
                        onChange={e => onChangeInput(e.target.value)}
                        disabled={options.disabled}
                        autoComplete="off"
                        value={inputValue}
                        className="c-input__input  "
                        id={'select_free_' + options.id}
                        type="text"
                        placeholder="Buscar..."
                    />
                    <button
                        className={`c-input__addon  c-input__addon--no-background u-pl-none u-pr-none ${
                            options.disabled ? '__class_noMagnifying' : ''
                        }`}
                        style={{ cursor: 'context-menu' }}
                    >
                        <i className="c-icon  c-icon--[semantic-search]"></i>
                    </button>
                </div>

                <ul
                    id="ul_bronson"
                    className="c-custom-select__dropdown"
                    style={{ display: !display ? 'none' : 'inline' }}
                >
                    {filteredArrayValues.length !== 0 ? (
                        filteredArrayValues.map((valueOption, index) => {
                            return (
                                <li
                                    id={'li_bronson_' + index}
                                    key={index}
                                    className={
                                        'c-custom-select__item  ' +
                                        (valueOption.selected
                                            ? 'is-active'
                                            : '')
                                    }
                                    onClick={() => onChangeSelect(valueOption)}
                                >
                                    {valueOption[textDisplay]}
                                </li>
                            );
                        })
                    ) : options.loading ? (
                        <li
                            id="li_bronson_0"
                            className="c-custom-select__item  "
                        >
                            <Loader />
                        </li>
                    ) : (
                        <li
                            id="li_bronson_0"
                            className="c-custom-select__item  "
                        >
                            {options.default}
                        </li>
                    )}
                </ul>
            </div>
        </React.Fragment>
    );
}
SelectFreeMultiple.propTypes = {
    options: PropTypes.shape({
        name: PropTypes.string,
        label: PropTypes.string,
        id: PropTypes.string.isRequired,
        className: PropTypes.string,
        disabled: PropTypes.bool,
        values: PropTypes.array,
    }).isRequired,
    onChange: PropTypes.func.isRequired,
};

export function SelectFree({
    options,
    value,
    onChange,
    textDisplay = 'name',
    selectedId = 'id',
}) {
    const [arrayValues, setArrayValues] = useState([]);
    const [inputValue, setInputValue] = useState('');
    const [index, setIndex] = useState(0);
    const [display, setDisplay] = useState(true);
    const [setInitState, setSetInitState] = useState(true);

    useEffect(() => {
        let copy = options.values.map(item =>
            Object.defineProperty(item, 'selected', {
                value:
                    options.defaultValue && item.id == options.defaultValue
                        ? true
                        : false,
                writable: true,
            })
        );
        if (setInitState) {
            if (options.defaultValue) {
                let item = copy.find(item => item.id == options.defaultValue);
                if (item) {
                    setInputValue(item[textDisplay]);
                    onChange(item.id);
                } else {
                    onChangeInput('');
                    setDisplay(true);
                }
            }
            setSetInitState(false);
        }
        setArrayValues(copy);
    }, [options.values]);

    useEffect(() => {
        if (!value) {
            if (!options.defaultValue) onChangeInput('');
            setDisplay(true);
        }
    }, [value]);

    const onClickDropDown = () => {
        if (value === 0 && options.value) {
            options.values[0].selected = true;
        }
        setDisplay(false);
        document.getElementById('select_free_' + options.id).focus();
    };

    const onChangeInput = value => {
        if (arrayValues.length > 0) arrayValues[index].selected = false;
        setDisplay(false);
        setIndex(0);
        setInputValue(value);
        setArrayValues(
            options.values.filter(valueOption =>
                valueOption[textDisplay]
                    .toLowerCase()
                    .includes(value.toLowerCase())
            )
        );
    };

    const onChangeSelect = selectValue => {
        if (arrayValues.length > 0) {
            onChange(selectValue[selectedId]);
            options.values.forEach(valueOption => {
                if (valueOption[selectedId] === selectValue[selectedId]) {
                    valueOption.selected = true;
                    setInputValue(valueOption[textDisplay]);
                } else {
                    valueOption.selected = false;
                }
            });
            setDisplay(true);
        }
    };

    const onFocusOut = () => {
        setTimeout(() => {
            setDisplay(true);
        }, 300);
    };

    const onKeyPress = e => {
        var ul = document.getElementsByClassName(
            'c-custom-select__dropdown'
        )[0];
        var li = document.querySelector('#li_bronson_' + index).offsetTop;
        switch (e.key) {
            case 'Enter':
                onChangeSelect(arrayValues[index]);
                setDisplay(true);
                break;
            case 'ArrowUp':
                if (index > 0) arrayValues[index].selected = false;
                if (index > 0) arrayValues[index - 1].selected = true;
                if (index > 0) setIndex(index - 1);
                ul.scroll({ behavior: 'smooth', top: li - 100 });
                break;
            case 'ArrowDown':
                if (index < arrayValues.length - 1)
                    arrayValues[index].selected = false;
                if (index < arrayValues.length - 1)
                    arrayValues[index + 1].selected = true;
                if (index < arrayValues.length - 1) setIndex(index + 1);
                ul.scroll({ behavior: 'smooth', top: li });
                break;
            default:
                break;
        }
    };

    const showLabel = label => {
        if (label) {
            return <label className="c-form-field__label">{label}</label>;
        }
    };

    return (
        <React.Fragment>
            {showLabel(options.label)}
            <div className="c-custom-select">
                <div className="c-input">
                    <input
                        onBlur={onFocusOut}
                        onKeyPress={e => onKeyPress(e)}
                        onFocus={onClickDropDown}
                        onChange={e => onChangeInput(e.target.value)}
                        disabled={options.disabled}
                        autoComplete="off"
                        value={inputValue}
                        className="c-input__input  "
                        id={'select_free_' + options.id}
                        type="text"
                        placeholder="Buscar..."
                    />
                    <button
                        className={`c-input__addon  c-input__addon--no-background u-pl-none u-pr-none ${
                            options.disabled ? '__class_noMagnifying' : ''
                        }`}
                        style={{ cursor: 'context-menu' }}
                    >
                        <i className="c-icon  c-icon--[semantic-search]"></i>
                    </button>
                </div>

                <ul
                    id="ul_bronson"
                    className="c-custom-select__dropdown"
                    style={{ display: display ? 'none' : 'inline' }}
                >
                    {arrayValues.length !== 0 ? (
                        arrayValues.map((valueOption, index) => {
                            return (
                                <li
                                    id={'li_bronson_' + index}
                                    key={index}
                                    className={
                                        'c-custom-select__item  ' +
                                        (valueOption.selected
                                            ? 'is-active'
                                            : '')
                                    }
                                    onClick={() => onChangeSelect(valueOption)}
                                >
                                    {valueOption[textDisplay]}
                                </li>
                            );
                        })
                    ) : options.loading ? (
                        <li
                            id="li_bronson_0"
                            className="c-custom-select__item  "
                        >
                            <div
                                className="c-spinner  c-spinner--small"
                                aria-live="polite"
                                aria-busy="true"
                            >
                                <div className="c-spinner__loader">
                                    <span className="c-spinner__element"></span>
                                    <span className="c-spinner__element"></span>
                                    <span className="c-spinner__element"></span>
                                    <span className="c-spinner__element"></span>
                                    <span className="c-spinner__element"></span>
                                    <span className="c-spinner__element"></span>
                                    <span className="c-spinner__element"></span>
                                    <span className="c-spinner__element"></span>
                                </div>
                            </div>{' '}
                        </li>
                    ) : (
                        <li
                            id="li_bronson_0"
                            className="c-custom-select__item  "
                        >
                            {options.default}
                        </li>
                    )}
                </ul>
            </div>
        </React.Fragment>
    );
}
SelectFree.propTypes = {
    options: PropTypes.shape({
        name: PropTypes.string,
        label: PropTypes.string,
        id: PropTypes.string.isRequired,
        className: PropTypes.string,
        disabled: PropTypes.bool,
        values: PropTypes.array,
    }).isRequired,
    onChange: PropTypes.func.isRequired,
};

export const ButtonGroup = ({
    multiple,
    onChange,
    elements,
    value,
    loading,
    defaultValue,
}) => {
    const [arrayValues, setArrayValues] = useState([]);
    const [setInitState, setSetInitState] = useState(true);

    useEffect(() => {
        let copy = elements.map(item =>
            Object.defineProperty(item, 'selected', {
                value: false,
                writable: true,
            })
        );
        if (setInitState) {
            if (defaultValue) {
                if (multiple) {
                    for (const iterator of defaultValue) {
                        let indexCopy = copy.findIndex(
                            item => item.id == iterator
                        );
                        if (indexCopy > -1) {
                            copy[indexCopy].selected = true;
                        }
                    }

                    let copySelected = copy.filter(
                        item => item.selected == true
                    );
                    let selectedValues = copySelected.map(item => item.id);
                    onChange(selectedValues);
                } else {
                    let indexCopy = copy.findIndex(
                        item => item.id == defaultValue
                    );
                    if (indexCopy > -1) {
                        copy[indexCopy].selected = true;
                    }
                    onChange(copy[indexCopy.id]);
                }
            }
            setSetInitState(false);
        }
        setArrayValues(copy);
    }, [elements]);

    const addElement = id => {
        let duplicate = [...arrayValues];
        let index = duplicate.findIndex(item => item.id == id);
        duplicate[index].selected = true;
        let selectedValues = duplicate
            .filter(item => item.selected == true)
            .map(item => item.id);
        if (multiple) {
            onChange(selectedValues);
        } else {
            onChange(selectedValues[0]);
        }
        setArrayValues(duplicate);
    };

    const removeElement = id => {
        let duplicate = [...arrayValues];
        let index = duplicate.findIndex(item => item.id == id);
        duplicate[index].selected = false;
        let selectedValues = duplicate
            .filter(item => item.selected == true)
            .map(item => item.id);

        if (multiple) {
            onChange(selectedValues);
        } else {
            onChange(selectedValues.length == 0 ? null : selectedValues[0]);
        }
        setArrayValues(duplicate);
    };

    const changeElement = (e, id) => {
        if (e.target.checked) {
            addElement(id);
        } else {
            removeElement(id);
        }
    };

    const getRender = () => {
        return !loading ? (
            <div className="c-button-group">
                {arrayValues.map(item => (
                    <label
                        key={item.id + '__button-group'}
                        className="c-button-group__item"
                        htmlFor={`button-group-item-bronson-button-group--button-group-more-items-${item.id}`}
                    >
                        <input
                            className="c-button-group__input"
                            type={multiple ? 'checkbox' : 'radio'}
                            name="button-group-item-bronson-button-group--button-group-more-items"
                            id={`button-group-item-bronson-button-group--button-group-more-items-${item.id}`}
                            onChange={e => changeElement(e, item.id)}
                            checked={item.selected}
                        />
                        <span className="c-button-group__label">
                            {item.name}
                        </span>
                    </label>
                ))}
            </div>
        ) : (
            <Loader />
        );
    };
    return getRender();
};

export const Loader = () => (
    <div className="o-layout">
        <div className="o-layout__item  u-1/1">
            <div className="o-layout__item  u-3/3 u-mb ">
                {' '}
                {/*__class_bg-alternative*/}
                <div className="__class_Loader">
                    <div id="loadingHeader" className="spinner">
                        <center>
                            <div
                                className="c-spinner c-spinner--small"
                                aria-live="polite"
                                aria-busy="true"
                            >
                                <div className="c-spinner__loader">
                                    <span className="c-spinner__element"></span>
                                    <span className="c-spinner__element"></span>
                                    <span className="c-spinner__element"></span>
                                    <span className="c-spinner__element"></span>
                                    <span className="c-spinner__element"></span>
                                    <span className="c-spinner__element"></span>
                                    <span className="c-spinner__element"></span>
                                    <span className="c-spinner__element"></span>
                                </div>
                            </div>
                        </center>
                    </div>
                </div>
            </div>
        </div>
    </div>
);

export function FakeInputs({ totalInputs }) {
    const waveStyle = (height, marginBotton, width) => {
        return {
            height: `${height}px`,
            width: `${width}%`,
            backgroundColor: '#dee1e3',
            borderRadius: '5px',
            backgroundImage:
                'linear-gradient(90deg, #dee1e3 0px, #ffffff26 40px, #dee1e3 80px)',
            backgroundSize: '600px',
            // -webkit-animation: shine-avatar 1.6s infinite linear,
            animation: 'shine-avatar 1.6s infinite linear',
            marginBottom: `${marginBotton}px`,
        };
    };

    return (
        <div
            className={`o-layout__item u-1/1@s u-1/2@m u-1/${totalInputs}`}
            style={{
                display: 'inline-block',
                marginBottom: '20px',
                margintop: '15px',
            }}
        >
            <div className="o-layout__item">
                <div
                    className="o-layout__item"
                    style={waveStyle(15, 15, 50)}
                ></div>
                <div
                    className="o-layout__item"
                    style={waveStyle(45, 5, 100)}
                ></div>
            </div>
        </div>
    );
}

//#endregion

//#region Dealer Service
const CanalsService = {
    getDealers: async ({ baseURL, idCliente, idDealer }) => {
        let body = { Codigo: idDealer };
        return HelperService.post(baseURL, body).then(response => {
            if (response.body && response.error && response.error.length == 0) {
                const parseBody = response.body.map(item => {
                    return {
                        id: item.Codigo,
                        name:
                            HelperService.capitalizefirstletter(item.Nombre) +
                            ' ' +
                            HelperService.capitalizefirstletter(
                                item.Apellido1
                            ) +
                            ' ' +
                            HelperService.capitalizefirstletter(item.Apellido2),
                    };
                });
                return parseBody;
            } else return null;
        });
    },

    getDealership: async ({ token, baseURL, idCliente, group, region }) => {
        let _body = { UsuarioId: idCliente };
        if (region) _body.Region = region.toString();
        if (group) _body.GrupoRappel = group.toString();
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
        };
        let response = await HelperService.post(baseURL, _body, config);
        if (response.body && response.error && response.error.length == 0) {
            const parseBody = response.body.map(item => {
                return {
                    id: item.IdCanal,
                    name: item.NombreCanal,
                };
            });
            return parseBody;
        } else {
            console.error(response.body);
            throw {
                message: `${response.error[0].code} Error en el llamado al servidor. Message : ${response.error[0].value}`,
            };
        }
    },

    getRegions: async ({ baseURL, idCliente }) => {
        let response = await HelperService.post(baseURL, {
            UsuarioId: idCliente,
        });
        if (response.body && response.error && response.error.length == 0) {
            const parseBody = response.body.map(item => {
                return {
                    id: item.Codigo,
                    name: item.Descripcion,
                };
            });
            return parseBody;
        } else
            throw {
                message: `${response.error[0].code} Error en el llamado al servidor. Message : ${response.error[0].value}`,
            };
    },

    getGroups: async ({ baseURL, idCliente, region }) => {
        let body = { UsuarioId: idCliente };
        if (region) body.Region = region.toString();
        let response = await HelperService.post(baseURL, body);
        if (response.body && response.error && response.error.length == 0) {
            const parseBody = response.body.map(item => {
                return {
                    id: item.Codigo,
                    name: item.Descripcion,
                };
            });
            return parseBody;
        } else
            throw {
                message: `${response.error[0].code} Error en el llamado al servidor. Message : ${response.body.error[0].value}`,
            };
    },
};
//#endregion

//#region HelperService
const HelperService = {
    capitalizefirstletter(word) {
        if (word) {
            return word[0].toUpperCase() + word.slice(1).toLowerCase();
        } else {
            return '';
        }
    },
    post: async function (url, body, config) {
        var data = {};
        data.Body = JSON.stringify(body);
        try {
            let response = await axios.post(url, data, config);
            let parse = JSON.parse(response.data.body);
            response.data.body = parse.Result;
            if (parse.Error) response.data.error = parse.Error;
            if (parse.Errors) response.data.error = parse.Errors;
            return response.data;
        } catch (error) {
            let response = {};
            let statusCode = error.response ? error.response.status : 500;
            let errorMsg = error.response ? error.response.statusText : 'Error';
            response.statusCode = statusCode;
            response.body = {};
            response.body.error = [];
            response.body.error.push({ code: statusCode, value: errorMsg });
            return response;
        }
    },
};
//#endregion
